export default __webpack_public_path__ + "static/media/Background_00200.211e93a7.png";